import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PlatformCustomCoversQuery } from "../graphql/queries";
import type { PlatformCustomCoversQueryType } from "@/types/graphql/partner.generated";

export const usePlatformCustomCoversQuery = (
  options?: QueryHookOptions<PlatformCustomCoversQueryType>
) => {
  return useQuery<PlatformCustomCoversQueryType>(
    PlatformCustomCoversQuery,
    options
  );
};
